import Photo from './Photo';
import ExternalTour from './ExternalTour';
import LayoutPhoto from './LayoutPhoto';
import VrModel from './VrModel';
import FloorPlanAmenity from './FloorPlanAmenity';
import Unit from './Unit';
import RoomForRent from './RoomForRent';

import type { PhotoProps } from '@zg-rentals/maintenance-utils';
import type { ExternalTourProps } from './ExternalTour';
import type { LayoutPhotoProps } from './LayoutPhoto';
import type { VrModelProps } from './VrModel';
import type { FloorPlanAmenityProps } from './FloorPlanAmenity';
import type { UnitProps } from './Unit';
import type { RoomForRentProps } from './RoomForRent';

export type FloorPlanProps = {
  active?: boolean;
  baths?: string | number;
  beds?: string | number;
  numBathrooms?: string;
  numBedrooms?: string;
  dateAvailable?: string;
  description?: string;
  externalTour?: Partial<ExternalTourProps>;
  floorPlanId?: string;
  floorPlanPhotos?: Array<PhotoProps>;
  highPrice?: string;
  id?: string;
  layoutPhoto?: Partial<LayoutPhotoProps>;
  lowPrice?: string;
  name?: string;
  price?: string;
  securityDeposit?: string;
  squareFeet?: string;
  unitAmenities?: Array<FloorPlanAmenityProps>;
  units?: Array<UnitProps>;
  vrModel?: VrModelProps;
  roomForRent?: Partial<RoomForRentProps>;
};

const FloorPlan = ({
  active = false,
  baths = '',
  beds = '',
  numBathrooms = '',
  numBedrooms = '',
  dateAvailable = '',
  description = '',
  externalTour = {},
  floorPlanId = '',
  floorPlanPhotos = [],
  highPrice = '',
  id = '',
  layoutPhoto = {},
  lowPrice = '',
  name = '',
  price = '',
  securityDeposit = '',
  squareFeet = '',
  unitAmenities = [],
  units = [],
  vrModel = {},
  roomForRent = {},
}: FloorPlanProps = {}): FloorPlanProps => ({
  active: Boolean(active),
  baths: baths ? String(baths) : String(numBathrooms),
  beds: beds || Number(beds) === 0 ? String(beds) : String(numBedrooms),
  dateAvailable: String(dateAvailable),
  description: String(description),
  externalTour: ExternalTour(externalTour),
  floorPlanId: String(floorPlanId),
  floorPlanPhotos: floorPlanPhotos.map(Photo),
  highPrice: String(highPrice),
  id: String(id),
  layoutPhoto: LayoutPhoto(layoutPhoto),
  lowPrice: String(lowPrice),
  name: String(name),
  price: String(price),
  securityDeposit: String(securityDeposit),
  squareFeet: String(squareFeet),
  unitAmenities: unitAmenities.map(FloorPlanAmenity),
  units: units.map(Unit),
  vrModel: VrModel(vrModel),
  roomForRent: RoomForRent(roomForRent),
});

export default FloorPlan;
